/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByKeywordKind = (typeof GroupByKeywordKind)[keyof typeof GroupByKeywordKind];

export const GroupByKeywordKind = {
  keyword: 'keyword',
} as const;
